export default function NavigationItemNext({ page, totalPages, goToPage, className = "" }) {

  return (
    <li className={className}>
      <a
        className={`arrow ${page + 1 > totalPages ? 'disabled' : ''}`}
        onClick={(e) => { e.preventDefault(); goToPage(page + 1) }}
        href="#">
          &nbsp;
      </a>
    </li>
  )
}